import { Dayjs } from "dayjs";
import { SortType } from "../../SortType";
import { AccountSortBy, YearBasis } from "./AccountManagement";

export interface AccountManagementFilters {
  poc_id: number | null;
  category_id: number | null;
  subcategory_id: number | null;
  min_ltv: number | null;
  max_ltv: number | null;
  year_basis: YearBasis;
  min_year_rev: number | null;
  max_year_rev: number | null;
  last_from: Dayjs | null;
  last_to: Dayjs | null;
  q: string;
  sort_by: AccountSortBy;
  sort_type: SortType;
  page_no: number;
  limit: number;
}

export const defaultAccountManagementFilters = (): AccountManagementFilters => ({
  poc_id: null,
  category_id: null,
  subcategory_id: null,
  min_ltv: null,
  max_ltv: null,
  year_basis: "current",
  min_year_rev: null,
  max_year_rev: null,
  last_from: null,
  last_to: null,
  q: "",
  sort_by: "lifetime_value",
  sort_type: SortType.DESC,
  page_no: 1,
  limit: 30,
});
